import { Agent } from 'src/interfaces/agent.interface';
import { PostCallPromptSection } from './PostCallPromptSection';
import { PostCallActionsSection } from './PostCallActionsSection';
import { PostCallActivityTracking } from './PostCallActivityTracking';
import { PostCallDataExtractionSection } from './PostCallDataExtractionSection';
import { CustomPostCallApiSection } from './CustomPostCallApiSection';
import { useEnvironment } from 'src/contexts/EnvironmentContext';

type PostCallProps = {
  agent: Agent;
  setAgent: (value: React.SetStateAction<Agent>) => void;
  loading: boolean;
};

export const PostCall = ({ agent, setAgent, loading }: PostCallProps) => {
  const { environmentData } = useEnvironment();
  const hasPostCallPrompt = !!agent.post_call_prompt?.trim();

  return (
    <div>
      {hasPostCallPrompt ? (
        <PostCallPromptSection
          agent={agent}
          setAgent={setAgent}
          loading={loading}
        />
      ) : (
        <PostCallDataExtractionSection
          agent={agent}
          setAgent={setAgent}
          loading={loading}
        />
      )}

      <hr className="my-4" />

      <PostCallActionsSection
        agent={agent}
        setAgent={setAgent}
        loading={loading}
      />

      <hr className="my-4" />

      <PostCallActivityTracking
        agent={agent}
        setAgent={setAgent}
        loading={loading}
      />

      {environmentData?.features?.enableExperimentalFeatures && (
        <>
          <hr className="my-4" />
          <CustomPostCallApiSection
            agent={agent}
            setAgent={setAgent}
            loading={loading}
          />
        </>
      )}
    </div>
  );
};
